import { AxiosError } from 'axios';
import {
  AXIOS_TIMEOUT_CODES,
  AXIOS_ERROR_IDS,
  AXIOS_ERROR_CODES,
} from 'models/Error';
import { ErrorViewedProps } from 'models/MixpanelEvents';
import {
  ErrorMessageValue,
  ERROR_TYPES,
  ErrorMessageKey,
} from 'request-responses';

export const getAxiosErrorMessageCode = (
  error: AxiosError,
): ErrorMessageValue => error?.response?.data?.messageCode || '';

export const getAxiosErrorStatusCode = (error: AxiosError) =>
  error?.response?.data?.error?.statusCode || error.response?.status;

export const getAxiosErrorId = (error: AxiosError, customMessage?: string) => {
  const id = getAxiosErrorMessageCode(error);

  const { code, message, response } = error || {};

  if (id) return id;

  if (AXIOS_TIMEOUT_CODES.includes(code)) return AXIOS_ERROR_IDS.TIMEOUT;

  if (code === AXIOS_ERROR_CODES.CANCELED) return AXIOS_ERROR_IDS.CANCELED;

  if (message === AXIOS_ERROR_CODES.NETWORK)
    return navigator?.onLine
      ? AXIOS_ERROR_IDS.NETWORK_ERROR
      : AXIOS_ERROR_IDS.OFFLINE;

  if (error && !response) return AXIOS_ERROR_IDS.NETWORK_ERROR;

  if (error && response) return AXIOS_ERROR_IDS.UNKNOWN_SERVER_ERROR;

  return customMessage || AXIOS_ERROR_IDS.NON_AXIOS_ERROR;
};

export const getMixpanelErrorProps = (
  error: AxiosError | unknown,
  customMessage?: string,
) => {
  const axiosError = error as AxiosError;

  const id = getAxiosErrorId(axiosError, customMessage);
  const errorCode = getAxiosErrorStatusCode(axiosError);

  const errorKey = Object.keys(ERROR_TYPES).find(
    (k) => ERROR_TYPES[k as ErrorMessageKey] === id,
  );

  return {
    id: [id, errorKey].filter(Boolean).join(' - ') || '',
    errorCode,
  } as ErrorViewedProps;
};
